module.exports = __webpack_public_path__ + "static/media/f.c51f73a3.png";